export default __webpack_public_path__ + "static/media/Down.be892908.svg";